<div class="dialog" [class.open]="open" (click)="backdropClick($event)">
  <div class="dialog-content">
    <ng-content></ng-content>
  </div>
</div>
